/*
 * @Author: Junchi Zhao
 * @LastEditors: lgg
 * @Description:
 */
import api from '@/data/fetchType.js';
function getFlowTmplList(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/tmpl/getFlowTmplList', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}
// 查询流程模板
function getFlowTmpl(id) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/tmpl/getFlowTmpl', id)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

// 查询流程模板
function getFlowTmplRecord(id) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/flowtmpl/record/doGetById', id)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

// 查询流程模板
function getbpmnXml(procInstId) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/tmpl/getBpmnxmlByProcInstId', procInstId)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function addFlowTmpl(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/tmpl/addFlowTmpl', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function copyFlowTmpl(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/tmpl/copyFlowTmpl', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function editFlowTmpl(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/tmpl/editFlowTmpl', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function editFlowTmplXml(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/tmpl/editFlowTmplXml', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function delFlowTmpl(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/tmpl/delFlowTmpl', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

function deploy(params) {
  return new Promise((resolve, reject) => {
    api
      .formPost('/api/flow/tmpl/deploy', params)
      .then((res) => {
        resolve(res);
      })
      .catch((e) => {
        reject(e);
      });
  });
}

export {
  getFlowTmplList,
  addFlowTmpl,
  copyFlowTmpl,
  editFlowTmpl,
  editFlowTmplXml,
  getFlowTmpl,
  delFlowTmpl,
  deploy,
  getbpmnXml,
  getFlowTmplRecord
};
